/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionFieldCondition } from './QuestionFieldCondition';
import {
    QuestionFieldConditionFromJSON,
    QuestionFieldConditionFromJSONTyped,
    QuestionFieldConditionToJSON,
    QuestionFieldConditionToJSONTyped,
} from './QuestionFieldCondition';

/**
 * 
 * @export
 * @interface BidirectionalActionConfigTextMessage
 */
export interface BidirectionalActionConfigTextMessage {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    required: boolean;
    /**
     * 
     */
    max_length?: number;
    /**
     * 
     */
    is_required_for_subcategory_map?: { [key: string]: any; };
    /**
     * 
     */
    required_if?: QuestionFieldCondition;
    /**
     * 
     */
    enabled_if?: QuestionFieldCondition;
    /**
     * 
     */
    disabled_helper_text?: string;
}

/**
 * Check if a given object implements the BidirectionalActionConfigTextMessage interface.
 */
export function instanceOfBidirectionalActionConfigTextMessage(value: object): value is BidirectionalActionConfigTextMessage {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigTextMessageFromJSON(json: any): BidirectionalActionConfigTextMessage {
    return BidirectionalActionConfigTextMessageFromJSONTyped(json, false);
}

export function BidirectionalActionConfigTextMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigTextMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'required': json['required'],
        'max_length': json['max_length'] == null ? undefined : json['max_length'],
        'is_required_for_subcategory_map': json['is_required_for_subcategory_map'] == null ? undefined : json['is_required_for_subcategory_map'],
        'required_if': json['required_if'] == null ? undefined : QuestionFieldConditionFromJSON(json['required_if']),
        'enabled_if': json['enabled_if'] == null ? undefined : QuestionFieldConditionFromJSON(json['enabled_if']),
        'disabled_helper_text': json['disabled_helper_text'] == null ? undefined : json['disabled_helper_text'],
    };
}

export function BidirectionalActionConfigTextMessageToJSON(json: any): BidirectionalActionConfigTextMessage {
    return BidirectionalActionConfigTextMessageToJSONTyped(json, false);
}

export function BidirectionalActionConfigTextMessageToJSONTyped(value?: BidirectionalActionConfigTextMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'required': value['required'],
        'max_length': value['max_length'],
        'is_required_for_subcategory_map': value['is_required_for_subcategory_map'],
        'required_if': QuestionFieldConditionToJSON(value['required_if']),
        'enabled_if': QuestionFieldConditionToJSON(value['enabled_if']),
        'disabled_helper_text': value['disabled_helper_text'],
    };
}

